<template>
    <div class="point_list">
        <br>
        <ul>
            <li class="point-info" v-for="point in points" :key="point.puntored_id" @click="onResultElementClick(point)">
                <h1>{{ point.nombre_comercial }}</h1>
                <hr>
                <ul>
                    <li>
                        <strong>Código: </strong>
                        <span>{{point.puntored_id}}</span>
                    </li>
                    <li>
                        <strong>Dirección: </strong>
                        <span>{{point.direccion}}</span>
                    </li>
                    <li>
                        <strong>Ciudad: </strong>
                        <span>{{point.nombre_ciudad}}</span>
                    </li>
                    <li>
                        <strong>Departamento: </strong>
                        <span>{{point.nombre_departamento}}</span>
                    </li>
                    <li>
                        <strong>Horario: </strong>
                        <span>{{point.horario}}</span>
                    </li>
                    <li>
                        <strong>Distancia: </strong>
                        <span>{{point.DISTANCIA}}m</span>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    'name': "PointList",
    props: {
        points : {
            type: Array,
            default: []
        }
    },
    methods: {
        onResultElementClick(point) {
            this.$emit("onSelectElementOfList", point);
        }
    }
}
</script>
<style lang="scss">
   
</style>


